import { Button } from "../../Atoms/Button";
import { SubTitle } from "../../Atoms/SubTitle";
import { Title } from "../../Atoms/Title";
import { LayoutTemplate } from "../../Templates/LayoutTemplate";
import { Card } from "./Components/Card";
import { useTrainings } from "./useTrainings";

const video1 = "dQw4w9WgXcQ"; // Teste com este ID público

export const Trainings = () => {
  const { navigate } = useTrainings();

  return (
    <LayoutTemplate>
      <div className="py-16">
        <Title className="!text-center">Treinamentos</Title>
        <SubTitle className="text-center text-[#2d2d2d] mb-8">
          Acesse os treinamentos institucionais e operacionais disponíveis para
          você.
        </SubTitle>

        <div className="flex mx-auto max-w-5xl justify-start flex-wrap gap-8">
          <Card className="w-full max-w-md">
            <div className="flex justify-between items-center mb-6">
              <img
                src="/assets/svgs/icon-school.svg"
                alt="icone cartola"
                className="w-[52px] h-[52px]"
              />
              <p className="px-4 py-1 border border-solid border-[#E7EDEC] rounded-[100px]">
                Onboarding
              </p>
            </div>

            <div>
              <h2 className="text-xl mb-4">Processo de Vistoria Veicular</h2>
              <p className="mb-4">
                Procedimentos, orientações e boas práticas para a realização de
                vistorias veiculares.
              </p>

              <div className="flex flex-col gap-4 pb-6">
                <div className="flex gap-3 items-center">
                  <img
                    src="/assets/svgs/icon-play-green.svg"
                    alt="icone play"
                  />
                  <p>1 vídeo</p>
                </div>
                <div className="flex gap-3 items-center">
                  <img
                    src="/assets/svgs/icon-clock-green.svg"
                    alt="icone  relogio"
                  />
                  <p>20 min</p>
                </div>
              </div>
            </div>

            <Button
              className="!w-full"
              onClick={() => navigate(`/treinamentos/${video1}`)}
            >
              Ver treinamento{" "}
              <img src="/assets/svgs/arrow-right.svg" alt="icone seta" />
            </Button>
          </Card>
        </div>
      </div>
    </LayoutTemplate>
  );
};
